import request from '@/utils/request'
/**
 * 获取权限内的一级菜单
 */
export function getTopMenu() {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/Authority/RootModuleList',
        method: 'get',
        noModuleID: true,
    })
}
/** 根据一级菜单获取机构树
 * @param {moduleID} 一级菜单ID
 */
export function getMenuTree(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/Authority/SonModuleTree',
        method: 'get',
        params: data,
        noModuleID: true,
        ansycLoad: true
    })
}
/** 验证菜单
 * @param {moduleID} 菜单ID
 */
export function checkMenuAuth(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/Authority/ModuleAction',
        method: 'get',
        params: data
    })
}


/** 菜单列表
 * @param {moduleID} 菜单ID
 */
export function getModuleList() {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetHeadListRegister',
        method: 'get',
    })
}


export function getModuleListAuth() {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/Authority/ModuleList',
        method: 'get',
    })
}

export function transferAuthority(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/Authority/TransferAuthority',
        method: 'get',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/authority.js